import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Website} from "../../../website";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-ecommerce-view-header',
    templateUrl: './ecommerce-view-header.component.html',
    styleUrls: ['./ecommerce-view-header.component.scss'],
    standalone: false
})
export class EcommerceViewHeaderComponent implements OnInit {
  @Input() previewsPage: string;
  @Input() currentPage: string;
  @Input() previousPath: string = '.';
  @Input() website: Website;
  @Input() orderId: number;
  @Input() orderHasRefunds: boolean;
  @Input() fullRefunded?: boolean = false;
  @Input() orderHasTestPayment: boolean = false;

  isRefundActive = false;
  @Output() showRefundSection = new EventEmitter<[boolean, boolean]>();

  constructor(private _router: Router,
              private readonly _googleAnalyticsService: GoogleAnalyticsService,
              private _activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }

  navigateBacK() {
    this._router.navigate([this.previousPath], {relativeTo: this._activatedRoute.parent});
  }
 toggleRefundSection(fullRefund: boolean = false) {
    this.isRefundActive = !this.isRefundActive;
    this.showRefundSection.emit([this.isRefundActive, fullRefund]);
    this.sendGaEvent();
  }

  public sendGaEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Refund button click',
      eventLabel: '10Web Payments',
      websiteId: this.website?.id
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
